export default {"src":"/_next/static/media/paperclip.0f03cf79.svg","height":44,"width":44};